import { parseJwt } from '../plugins/jwtparser'

const tokenWatcher = function () {
  const jwt = sessionStorage.getItem('jwt')
  try {
    if (jwt) {
      const decodedJwt = parseJwt(jwt)
      const expDate = new Date(decodedJwt.exp * 1000)
      const todaysDate = new Date()
      if (expDate < todaysDate) {
        sessionStorage.removeItem('jwt')
        window.location.href = window.location.origin
      }
    }
  } catch (error) {
    console.log('Could not watch token: ' + error)
  }
}

export {
  tokenWatcher
}



// WEBPACK FOOTER //
// ./src/plugins/tokenwatcher.js